import { jsx, Fragment } from 'react/jsx-runtime';

const TabPanel = ({ children }) => jsx(Fragment, { children: children });
TabPanel.tabType = 'TabPanel';

export { TabPanel };
